import React from 'react';
import { Helmet } from 'react-helmet-async';

// Reusable Meta component for consistent metadata across pages
const Meta = ({
  title,
  description,
  keywords,
  ogImage = 'https://auledgerapp.com/assets/images/auledger-social-share.jpg',
  ogType = 'website',
  twitterCard = 'summary_large_image'
}) => {
  // Format the title
  const formattedTitle = title ? `${title} | AuLedger` : 'AuLedger - Gold Portfolio Tracking App';
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{formattedTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={formattedTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:site_name" content="AuLedger" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={formattedTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Meta;